import { render, staticRenderFns } from "./privatizationAdd.vue?vue&type=template&id=ad70c60a&scoped=true"
import script from "./privatizationAdd.vue?vue&type=script&lang=ts"
export * from "./privatizationAdd.vue?vue&type=script&lang=ts"
import style0 from "./privatizationAdd.vue?vue&type=style&index=0&id=ad70c60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad70c60a",
  null
  
)

export default component.exports